import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {getTranslate} from 'react-localize-redux';
import Validator from 'validatorjs';
import api from '../../../helpers/api';
import {loadLanguage} from '../../../common/redux/localeReducer';
import {notifySuccess, notifyError} from '../../../common/redux/notificationReducer';
import {ContentLoader} from '../../../common/components/loader';
import {Error, Input} from '../../../common/components/form';
import {loginNewRules} from '../rules';
import login from '../locales/login.json';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

class LoginFormNew extends Component {
	constructor(props) {
		super(props);

		const {loadLanguage} = props;
		loadLanguage(login);

		this.state = {
			isLoading: false,
			redirectTo: false,
			errors: {},
			loginForm: {
				email: '',
				mobile: '',
				password: ''
			}
		}
	}

	updateState = (object) => {
		this.setState({
			loginForm: {
				...this.state.loginForm,
				...object
			}
		})
	};

	formSubmit = (e) => {
		e.preventDefault();
		const {loginForm} = this.state;

		let validation = new Validator(loginForm, loginNewRules.validators, loginNewRules.messages);
		if(validation.fails()) {
			return this.setState({errors: validation.errors.all()});
		}
		return this.handleSubmit(loginForm);
	};

	handleSubmit = async (values) => {
		const {notifySuccess, notifyError} = this.props;
		try {
			const response = await api.post('/auth/login', values);
			notifySuccess(response.message);

			this.setState({errors: {}, redirectTo: true});
		} catch (error) {
			notifyError(error.message);
		}
	};

	render() {
		const {translate} = this.props;
		const {errors, redirectTo, loginForm} = this.state;

		if (redirectTo) {
			return <Redirect to='/' />;
		}

		const content = (
			<div className="login-box-body box">
				<p className="login-box-msg">{translate('login_page_title')}</p>

				<form onSubmit={this.formSubmit}>

					<div className="form-group">
						<PhoneInput
							inputStyle={{width: '100%'}}
							country='us'
							enableSearch={true}
							masks={{bd: '.... ......'}}
							placeholder="Mobile"
							value={loginForm.mobile}
							onChange={value => this.updateState({mobile: value})}
						/>
						{errors.mobile && <Error text={translate(errors.mobile[0])} />}
					</div>

					<div className="form-group">
						<Input placeholder={translate('login_email_placeholder')} value={loginForm.email} onChange={e => this.updateState({email: e.target.value})} />
						{errors.email && <Error text={translate(errors.email[0])} />}
					</div>

					<div className="form-group">
						<Input placeholder={translate('login_password_placeholder')} type="password" value={loginForm.password} onChange={e => this.updateState({password: e.target.value})} />
						{errors.password && <Error text={translate(errors.password[0])} />}
					</div>

					<div className="row">
						<div className="col-xs-12 text-center">
							<button type="submit" className="btn btn-primary btn-inverse">
								{translate('login_submit_text')}
							</button>
						</div>
					</div>

				</form>

				<div className="social-auth-links text-center">
					<Link to="/auth/forgot-password" className="login-box-link">
						{translate('login_forgot_password_title')}
					</Link>
				</div>
			</div>
		);

		return translate('login_page_title') ? content : <ContentLoader/>;
	}
}

const mapStateToProps = state => ({
	translate: getTranslate(state.locale)
});

const mapDispatchToProps = dispatch => bindActionCreators({
	loadLanguage,
	notifySuccess,
	notifyError
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginFormNew);
